<quill-editor
  placeholder=""
  [ngClass]="{ 'toolbar-disabled': disabled }"
  [modules]="options.modules"
  theme="snow"
  [valueSetter]="value"
  [sanitize]="true"
  [bounds]="boundContainer || 'default'"
  [customOptions]="customOptions"
  [readOnly]="disabled"
  #editor
  (onContentChanged)="onValueChange($event)"
  (onEditorCreated)="handleEditorCreated()"
>
</quill-editor>
